module.exports = __webpack_public_path__ + "static/media/21.23b8612c.jpg";